module.exports = __webpack_public_path__ + "img/_DSC1287.7d6c7c6b.jpg";